<div class="avatar">
  <span>
    {{name[0]}}
  </span>
</div>

